import Clipboard from "clipboard";
import { ElMessage } from "element-plus";
import { t } from "@/utils";
const clipboardDirective = {
  mounted(el, binding) {
    const { arg, value } = binding;

    if (arg === "success") {
      el._v_clipboard_success = value;
    } else if (arg === "error") {
      el._v_clipboard_error = value;
    } else {
      const clipboard = new Clipboard(el, {
        text: () => binding.value,
        action: () => (binding.arg === "cut" ? "cut" : "copy"),
      });

      clipboard.on("success", (e) => {
        const callback = el._v_clipboard_success;
        callback && callback(e);
        ElMessage.success(t("common.copySuccess"));
      });

      clipboard.on("error", (e) => {
        const callback = el._v_clipboard_error;
        callback && callback(e);
        ElMessage.error(t("common.copyError"));
      });

      el._v_clipboard = clipboard;
    }
  },

  updated(el, binding) {
    if (binding.arg === "success") {
      el._v_clipboard_success = binding.value;
    } else if (binding.arg === "error") {
      el._v_clipboard_error = binding.value;
    } else {
      if (el._v_clipboard) {
        el._v_clipboard.text = () => binding.value;
        el._v_clipboard.action = () => (binding.arg === "cut" ? "cut" : "copy");
      }
    }
  },

  unmounted(el) {
    if (el._v_clipboard) {
      el._v_clipboard.destroy();
      delete el._v_clipboard;
    }
    delete el._v_clipboard_success;
    delete el._v_clipboard_error;
  },
};

export default clipboardDirective;
